import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//解决vue路由重复导航错误
//获取原型对象上的push函数

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'home',
        component: () => import('../views/index/index')
    },
    {
        path: '/service',
        name: 'service',
        component: () => import('../views/index/newindex')
    },
    {
        path: '/intelligent',
        name: 'intelligent',
        component: () => import('../views/znyd/toIndex')
    },
    {
        path: '/znyd',
        name: 'znyd',
        component: () => import('../views/znyd/index')
    },
    {
        path: '/znydQa',
        name: 'znydQa',
        component: () => import('../views/znyd/qaIndex')
    },
	{
	    path: '/list',
	    name: 'list',
	    component: () => import('../views/znyd/list')
	},
    {
        path: '/user',
        name: 'user',
        component: () => import('../views/userSpace/index')
    },
    {
        path: '/projectDetail',
        name: 'projectDetail',
        component: () => import('../views/userSpace/projectDetail')
    },
    {
        path: '/newitem',
        name: 'newitem',
        redirect: '/newitem/overview',
        component: () => import('../views/newItem/layout'),
        children: [
            {
                path: 'overview',
                name: 'overview',
                component: () => import('../views/newItem/overview.vue'),
            },
            {
                path: 'register',
                name: 'register',
                component: () => import('../views/newItem/register.vue'),
            },
            {
                path: 'addproject',
                name: 'addproject',
                component: () => import('../views/newItem/addProject.vue'),
            },
        ]
    },
	{
	    path: '/dtgl',
	    name: 'dtgl',
	    component: () => import('../views/xmdt/dtgl')
	},
	{
	    path: '/dtDetail',
	    name: 'dtDetail',
	    component: () => import('../views/xmdt/dtDetail')
	},
    {
        path: '/flowpath',
        name: 'flowpath',
        component: () => import('../views/flowPath/index')
    },
    {
        path: '/smartCheck',
        name: 'smartCheck',
        component: () => import('../views/smartCheck/index')
    },
    {
        path: '/housekeep',
        name: 'housekeep',
        component: () => import('../views/housekeep/index')
    },
    {
        path: '/housekeepHome',
        name: 'housekeepHome',
        component: () => import('../views/housekeep/home')
    },
    {
        path: '/processProgress',
        name: 'processProgress',
        component: () => import('../views/processProgress/processIndex')
    },
    {
        path: '/inform',
        name: 'inform',
        component: () => import('../views/inform/index.vue')
    },
    {
        path: '/searchs',
        name: 'searchs',
        component: () => import('../views/searchPage/index.vue')
    },
    {
        path: '/searchInfo',
        name: 'searchInfo',
        component: () => import('../views/infoSearch/infoIndex')
    },
    {
        path: '/chainGuide',
        name: 'chainGuide',
        component: () => import('../views/chain/guide/index')
    },
    {
        path: '/chainOnline',
        name: 'chainOnline',
        component: () => import('../views/chain/online/index')
    },
    {
        path: '/content/:type',
        name: 'content',
        component: () => import('@/views/content/index'),
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import('@/views/content/detail'),
    },
    {
        path: '/chain',
        name: 'chain',
        component: () => import('../views/chain/index')
    },
    {
        path: '/czzy',
        name: 'czzy',
        component: () => import('../views/czzy/index')
    }, {
        path: '/xzzq',
        name: 'xzzq',
        component: () => import('../views/content/download')
    },
	{
	    path: '/itemGuide',
	    name: 'itemGuide',
	    component: () => import('../views/item/guide/index')
	},
]

const router = new VueRouter({
    routes
})

export default router
